/**
 * Created by hp on 2017/6/6.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qs from 'qs'
import xss from 'xss';
import {removeAds, getTimestamp, TimeStream} from '../../utils';

import '../../styles/DiscussList.css'


class DiscussListItem extends Component {
    constructor() {
        super()
        this.onOperate = this.onOperate.bind(this)
    }

    onOperate() {
        const {discuss} = this.props;
        this.props.parent.onShowOperateMenu(discuss)
    }

    render() {
        const {discuss} = this.props;
        return (
            <div className="discuss-list-item">
                <div className="left-side">
                    <div className="avatar">
                        <img alt="" className="circle" src={discuss.account.small_avatar_url}/>
                    </div>
                </div>
                <div className="right-side">
                    <div className="nickname">{discuss.account.nickname}</div>
                    <div className="content">{xss(discuss.content)}</div>
                    <div className="time">{TimeStream(parseInt(discuss.timestamp, 10), 'YMD_HMS')}</div>

                    {discuss.published &&
                    <div className="pushed">
                        <i className="iconfont icon-duigou"></i>
                        已上墙
                    </div>
                    }
                </div>
                {
                    this.props.showOperate &&
                    <div className="operate-side">
                        <div className="operate" onClick={this.onOperate}>
                            <i className="iconfont icon-gengduo1"></i>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


class ClassroomDiscussList extends Component {
    state = {
        loading: true,
        offset: null,
        ended: false,
        operatingItem: null,
        discussListLength: 0,
    };

    handleBloackAccount() {
        this.context.page.hideMenu();

        const {id} = this.state.operatingItem.account;
        const discussId = this.state.operatingItem.id;
        let data = new FormData();
        data.append('account_id', id);
        axios.post(`/api/liveroom/${this.props.liveroom.id}/block_account`, data).then((response) => {
            if (response.data.code === 0) {
                axios.post(`/api/classroom/${this.props.lecture.id}/discuss/${discussId}/delete`).then((response) => {
                    if (response.data.code === 0) {
                        this.props.dispatch({
                            type: 'DISCUSS_DELETE',
                            payload: {
                                id: discussId
                            }
                        })
                    }
                })
                this.context.page.showTips('已拉黑该用户', 'primary')
            }
        });
    }

    onDeleteDiscuss() {
        this.context.page.hideMenu()

        const id = this.state.operatingItem.id
        axios.post(`/api/classroom/${this.props.lecture.id}/discuss/${id}/delete`).then((response) => {
            if (response.data.code === 0) {
                this.props.dispatch({
                    type: 'DISCUSS_DELETE',
                    payload: {
                        id: id
                    }
                })
                this.context.page.showTips('删除了一条评论', 'primary')
            }
        })
    }

    onPushDiscussToLectureMessage() {
        this.context.page.hideMenu()

        const id = this.state.operatingItem.id

        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)
        const data = {
            ts: timestamp
        }
        axios.post(`/api/classroom/${this.props.lecture.id}/discuss/${id}/publish`, qs.stringify(data)).then((response) => {
            this.props.dispatch({
                type: 'DISCUSS_TOGGLE',
                payload: {
                    id: id,
                    published: true
                }
            })
        })
    }

    onReplyToDiscuss() {
        this.context.page.hideMenu()

        const message = this.state.operatingItem
        const text = message.account.nickname + '：' + message.content
        this.props.dispatch({
            type: 'CLASSROOM_SET_REPLY',
            payload: text
        })
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_DISCUSS_PANEL'
        })
    }

    onShowOperateMenu(discuss) {
        const menus = [];
        if (this.props.role.is_lecturer) {
            if (!discuss.published) {
                menus.push({
                    label: '上墙到课堂',
                    onClick: this.onPushDiscussToLectureMessage.bind(this)
                })
            }
            menus.push({
                label: '回复评论',
                onClick: this.onReplyToDiscuss.bind(this)
            });
        }
        menus.push({
            label: '删除评论',
            className: 'danger',
            onClick: this.onDeleteDiscuss.bind(this)
        });
        if (this.props.role.is_manager) {
            menus.push({
                label: '拉黑',
                onClick: this.handleBloackAccount.bind(this)
            })
        }
        this.setState({operatingItem: discuss})
        this.context.page.showMenu(menus)
    }

    loadData(reload) {
        var params = {};
        if (reload)
            params.offset = null;
        else
            params.offset = this.state.offset;
        this.setState({loading: true});

        const {role} = this.props;
        axios.get('/api/classroom/' + this.props.lecture.id + '/discuss/list', {params: params}).then((response) => {
            if (response.data.code === 0) {
                let discussListLength = this.state.discussListLength + response.data.data.discusses.length;
                this.setState({
                    loading: false,
                    offset: response.data.data.next_offset,
                    ended: discussListLength <= 2000 ? !response.data.data.has_more : true,
                    discussListLength: discussListLength,
                })

                let discusses = response.data.data.discusses.map((item) => {
                    if (!role.is_manager) {
                        item.content = removeAds(item.content);
                    }
                    item.account.nickname = removeAds(item.account.nickname);
                    return item;
                });
                this.props.dispatch({
                    type: 'DISCUSS_APPEND',
                    payload: {
                        discusses: discusses
                    }
                })
            }
        });
    }

    reload() {
        this.props.dispatch({
            type: 'DISCUSS_INIT',
            payload: {
                lecture: this.props.lecture
            }
        })
        this.setState({offset: null, ended: false, showOperateMenu: false});
        this.loadData(true);
    }

    componentDidMount(nextProps) {
        this.reload()
    }

    hide() {
        this.setState({writing: false})
    }

    onScroll() {
        const scrollTop = this.refs.list.scrollTop;
        const {discussListLength} = this.state;

        if (this.state.loading || this.state.ended)
            return;
        if (scrollTop + this.refs.list.clientHeight + 300 > this.refs.list.scrollHeight && discussListLength <= 2000) {
            this.loadData();
        }
    }

    render() {
        const {account, role, discussList} = this.props
        const listHeight = (window.innerHeight || screen.height) * 0.6
        return <div className="discuss-list-container">

            <div className="discuss-list" style={{height: listHeight}}
                 onScroll={this.onScroll.bind(this)}
                 ref="list">
                {discussList.discusses.map((m) => {
                    return <DiscussListItem key={m.id} discuss={m} parent={this}
                                            showOperate={role.is_lecturer || m.account.id === account.id}/>;
                })}

                <div>
                    {!this.state.ended &&
                    <div className="loading"><i className="iconfont icon-jiazai"></i> 正在加载 </div>
                    }
                    {this.state.ended &&
                    <div className="ended"><i className="iconfont icon-duigou"></i> 加载完毕 </div>
                    }
                </div>
            </div>
        </div>
    }
}


ClassroomDiscussList.contextTypes = {
    page: React.PropTypes.object
};


ClassroomDiscussList = connect((state) => ({
    account: state.account,
    lecture: state.classroom.lecture,
    role: state.classroom.role,
    discussList: state.discussList,
    liveroom: state.classroom.liveroom,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomDiscussList)


export default ClassroomDiscussList



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomDiscussList.js